export default () => ({
	listing: {
		searchTerm: null,

		filter: {
			payload: null,
			where: null,
			isFiltering: false
		},

		page: 1
	}
})
